<template>
  <div class="sop_route_box">
    <el-card>
      <el-form
        :model="queryForm" size="mini"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <!-- 模块 -->
            <el-form-item :label="$t('collectionCenter.module')" prop="moduleId">
              <el-select
                v-model="queryForm.params.moduleId"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable filterable
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in moduleList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 菜单 -->
            <el-form-item :label="$t('navbar.menu')" prop="menuId">
              <el-select
                v-model="queryForm.params.menuId"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable filterable
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in menuList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 状态 -->
            <el-form-item :label="$t('trajectory.state')" prop="status">
              <el-select
                v-model="queryForm.params.status"
                :placeholder="$t('collectionCenter.tudo')"
                clearable filterable
                style="width: 100%"
              >
                <el-option :label="$t('GlobalSetObj.enable')" :value="1" />
                <el-option :label="$t('GlobalSetObj.disable')" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 创建人 -->
            <el-form-item :label="$t('userManage.creator')" prop="createUser">
              <el-select
                v-model="queryForm.params.createUser"
                :placeholder="$t('operationCenter.Only10AreDisplayed')"
                clearable filterable
                style="width: 100%"
                remote
                reserve-keyword
                :remote-method="getUserList"
                @clear="getUserList()"
              >
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.realName+'（'+item.createUserName+'）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <el-button
          icon="el-icon-search" size="small" type="primary"
          @click="search()"
        >{{ $t('newOrder.search') }}</el-button>
        <el-button icon="el-icon-refresh-right" size="small" @click="reset">{{ $t('newOrder.reset') }}</el-button>
      </div>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-button
        size="mini" icon="el-icon-plus" type="primary"
        style="margin-bottom: 10px"
        @click="addClick"
      >{{ $t('collectionCenter.add') }}</el-button>
      <el-table
        :data="tableData"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
        border style="width: 100%;border-radius: 0 !important"
      >
        <!-- 序号 -->
        <el-table-column
          :label="$t('collectionCenter.ind')" type="index" width="60"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!-- SOP编号 -->
        <el-table-column
          :label="$t('navbar.sopNumber')" prop="sopNo" align="center"
          width="230"
        >
          <template slot-scope="scope">
            <div class="text_class deepblue" @click="viewRow(scope.row)">
              {{ scope.row.sopNo }}
            </div>
          </template>
        </el-table-column>
        <!-- 模块 -->
        <el-table-column
          :label="$t('collectionCenter.module')" prop="moduleName" align="center"
          width="150"
        />
        <!-- 菜单 -->
        <el-table-column
          :label="$t('navbar.menu')" prop="menuName" align="center"
          width="150"
        />
        <!-- 状态 -->
        <el-table-column
          :label="$t('trajectory.state')" prop="status" align="center"
          width="90"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.status !== ''">
              <span v-if="scope.row.status === 1">{{ $t('GlobalSetObj.enable') }}</span>
              <span v-if="scope.row.status === 0">{{ $t('GlobalSetObj.disable') }}</span>
            </div>
            <span v-else>
              - -
            </span>
          </template>
        </el-table-column>
        <!-- 累计预览次数 -->
        <el-table-column
          :label="$t('navbar.totalPreviewCount')" prop="totalPreviewCount" align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            <div class="text_class blue" @click="totalCount(scope.row, $t('navbar.totalPreviewCount'), 1)">{{ scope.row.totalPreviewCount }}</div>
          </template>
        </el-table-column>
        <!-- 累计下载次数 -->
        <el-table-column
          :label="$t('navbar.totalDownloadCount')" prop="totalDownloadCount" align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            <div class="text_class blue" @click="totalCount(scope.row, $t('navbar.totalDownloadCount'), 1)">{{ scope.row.totalDownloadCount }}</div>
          </template>
        </el-table-column>
        <!-- 创建人 -->
        <el-table-column
          :label="$t('userManage.creator')" prop="createUserName" align="center"
          min-width="120"
        />
        <!-- 创建时间 -->
        <el-table-column
          :label="$t('Resource.CreationTime')" prop="createTime" align="center"
          min-width="120"
        />
        <!-- 修改人 -->
        <el-table-column
          :label="$t('userManage.ModifyThePerson')" prop="updateUserName" align="center"
          min-width="120"
        />
        <!-- 修改时间 -->
        <el-table-column
          :label="$t('userManage.ModificationTime')" prop="updateTime" align="center"
          min-width="120"
        />
        <!-- 操作 -->
        <el-table-column
          :label="$t('collectionCenter.operation')" align="center" width="260"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              size="small" round type="primary"
              @click="editRow(scope.row)"
            >{{ $t('CenterForSorting.modify') }}</el-button>

            <el-button
              size="small" round type="primary"
              @click="downloadClick(scope.row)"
            >{{ $t('navbar.downloadFile') }}</el-button><!--下载文件-->

            <span v-if="scope.row.status === 1 || scope.row.status === 0">
              <el-popconfirm
                :title="scope.row.status === 1 ? $t('basicData.AreYouSureDisabled') : $t('basicData.AreYouSureEnabled')"
                @confirm="changeState(scope.row, scope.row.status)"
              >
                <el-button
                  slot="reference" size="small" round
                  style="margin-left: 10px"
                  :class="scope.row.status === 1 ? 'gold_bg' : 'green_bg'"
                >{{ scope.row.status === 1 ? $t('basicData.disable') : $t('basicData.enable') }}</el-button>
              </el-popconfirm>
            </span>
          </template>
        </el-table-column>
      </el-table>

      <div class="right">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100, 500, 1000]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="search()"
          @size-change="search(1)"
        />
      </div>
    </el-card>

    <!-- 新增 / 编辑 / 查看 -->
    <addEdit
      ref="aeRef"
      :module-list="moduleList" :menu-list="menuList" :permission-list="permissionList"
      @search="search()"
    />

    <dialogChild ref="dialogRef" />
  </div>
</template>

<script>
import dialogChild from './dialogChild.vue';
import addEdit from './addEdit.vue';
import { getPermissionStructure } from '@/api/permission';
import { getUserPage } from '@/api/user';
import { sopPage, sopStatus, sopDownloadFile } from '@/api/sop';

import { getUserName } from '@/utils/asyncTools';
import { getUserIdAndNameObj } from '@/enums/storageEnum';

import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import dayjs from 'dayjs';

export default {
  name: 'Xxxxx',
  components: {
    dialogChild,
    addEdit
  },
  data() {
    return {
      queryForm: {
        pageNumber: 1,
        pageSize: 20,
        params: {
          createUser: '',
          moduleId: '',
          menuId: '',
          status: ''
        }
      },
      total: 0,
      tableData: [],
      moduleList: [],
      menuList: [],
      userList: [],
      permissionList: []
    };
  },
  created() {
    this.getMenu();
    this.getUserList();
  },
  methods: {
    reset() {
      this.queryForm.params = {
        createUser: '',
        moduleId: '',
        menuId: '',
        status: ''
      };
      this.search();
    },
    search(pageNumber) {
      if (pageNumber) {
        this.queryForm.pageNumber = pageNumber;
      }
      sopPage(this.queryForm).then(res => {
        if (res.code === 200) {
          this.total = res.data.total;
          this.tableData = res.data.records.map(item => {
            const updateUserName = getUserName(item.updateUser, getUserIdAndNameObj());
            const createUserName = getUserName(item.createUser, getUserIdAndNameObj());
            item.updateUserName = updateUserName;
            item.createUserName = createUserName;
            const module = this.moduleList.filter((itm) => itm.id === item.moduleId);
            const menu = this.menuList.filter((itm) => itm.id === item.menuId);
            item.moduleName = module && module.length > 0 ? module[0].name : '';
            item.menuName = menu && menu.length > 0 ? menu[0].name : '';
            return item;
          });
        }
      });
    },

    downloadClick(row) {
      sopDownloadFile(row.id).then(res => {
        if (res.code === 200) {
          console.log('文件url：', res.data);
          const fileList = res.data.documentList.map(item => {
            return {
              fileUrl: item.fileUrl,
              fileName: item.fileName
            };
          });
          console.log(fileList, 'fileList');
          const zipName = this.$t('navbar.sopPlatformExport') + '-' + dayjs().format('YYYYMMDDHHmmssSSS');
          this.downloadFilesAsZip(fileList, zipName);
        }
      });
    },
    // 打包压缩
    async downloadFilesAsZip(urls, zipName = 'download.zip') {
      const zip = new JSZip();
      await Promise.all(urls.map(async(url, index) => {
        const response = await fetch(url.fileUrl);
        const blob = await response.blob();
        zip.file(url.fileName, blob, { binary: true });
      }));
      const zipBlob = await zip.generateAsync({ type: 'blob' });
      saveAs(zipBlob, zipName);
    },

    changeState(row, status) {
      const statusForm = {
        sopId: row.id,
        status: status === 1 ? 0 : status === 0 ? 1 : null
      };
      console.log(statusForm, '===statusForm');
      sopStatus(statusForm).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('userManage.TheOperationSucceeded'));
          this.search();
        }
      });
    },
    totalCount(row, title, type) {
      console.log(row, title, type);
      // 传数据
      this.$nextTick(() => {
        this.$refs.dialogRef.getData(row, title, type);
      });
    },
    addClick(title) {
      this.$nextTick(() => {
        this.$refs.aeRef.openDrawer(null, 1, this.$t('navbar.addSOP'));
      });
    },
    editRow(row) {
      this.$nextTick(() => {
        this.$refs.aeRef.openDrawer(row, 2, this.$t('navbar.sopModify'));
      });
    },
    viewRow(row) {
      this.$nextTick(() => {
        this.$refs.aeRef.openDrawer(row, 3, this.$t('navbar.sopQuery'));
      });
    },

    // 模块 / 菜单
    getMenu() {
      getPermissionStructure().then((res) => {
        if (res.code === 200) {
          this.permissionList = res.data.permissionStructure;
          const mdL = [];
          res.data.permissionStructure.forEach(item => {
            mdL.push({ id: item.id, name: item.name });
          });
          this.moduleList = mdL;
          this.menuList = this.extractPages(res.data.permissionStructure);
          this.reset();
        }
      });
    },
    extractPages(treeData) {
      const result = [];
      const traverse = (items) => {
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          // 过滤掉按钮节点（btn: 开头）
          if (item.code && item.code.startsWith('btn:')) {
            continue;
          }
          // 判断是否有有效的菜单子节点（与 findLastLevelByFirstMenu 保持一致：严格匹配 menu: 前缀）
          const hasValidChildren = item.children && item.children.some(child => {
            return child.code && child.code.startsWith('menu:');
          });

          // 判断是否为末级节点
          const isLeaf = !item.children || item.children.length === 0 || !hasValidChildren;
          if (isLeaf && item.code && item.code.startsWith('menu:')) {
            result.push({
              id: item.id,
              name: item.name,
              code: item.code,
              parentId: item.parentId
            });
          } else {
            // 递归遍历子节点
            traverse(item.children);
          }
        }
      };
      traverse(treeData);
      return result;
    },
    // 创建人
    getUserList(usernameLike = '') {
      const param = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          accountState: '1',
          usernameLike
        }
      };
      getUserPage(param, false).then((res) => {
        if (res.code === 200) {
          this.userList = res.data.records;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.sop_route_box ::v-deep .el-table__header .el-table__cell .cell {
  font-weight: bold;
  font-size: 15px;
  color: #000;
}

.gold_bg {
  color: #fff;
  background: #ffb45d !important;
  border-color: #ffca8d !important;
  box-shadow: none !important;
  &:hover {
    background: #ffca8d !important;
    border-color: #ffca8d !important;
  }
  &:active {
    background: #ffb45d !important;
    border-color: #ffca8d !important;
  }
}
.green_bg {
  color: #fff;
  background: #14ac5f !important;
  border-color: #35aa6f !important;
  box-shadow: none !important;
  &:hover {
    background: #35aa6f !important;
    border-color: #35aa6f !important;
  }
  &:active {
    background: #14ac5f !important;
    border-color: #35aa6f !important;
  }
}

.text_class {
  text-decoration: underline;
  cursor: pointer;
}
.text_class.deepblue {
  color: #1f61ff;
}
.text_class.blue {
  color: #018be5;
}

.sop_dialog ::v-deep .el-dialog--center {
  text-align: left !important;
}

</style>
